/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSendSafelyPackageInformation} from '../api'

 export const useQueryGetSendSafelyPackageInformation = createReactQueryHook('getSendSafelyPackageInformation', getSendSafelyPackageInformation)
